import { GetMarkGroupListResponse } from '../kymw1500/api-services/get-mark-group-list.service';

/**
 * アイコン情報編集画面の値を管理するクラス
 *
 * @export KYMW1508Model
 * @class KYMW1508Model
 */
export class KYMW1508Model {
  /** アイコンコード */
  public iconCode: string;
  /** アイコン名 */
  public iconName: string;
  /** アイコングループ */
  public iconGroup: string;
  /** アイコン区分 */
  public iconDiv: string;
  /** 配置区分 */
  public arrangeDiv: string;
  /** アイコン説明 */
  public iconExplain: string;

  /** 出力区分 */
  /** 商品マスタ */
  public category: boolean = false;
  /** ウィークリー */
  public weekly: boolean = false;
  /** デイリー */
  public daily: boolean = false;
  /** 見切り品 */
  public logistics: boolean = false;
  /** 注文確認画面表示対象フラグ */
  public order: boolean = false;

  // 出力区分
  // 右から1文字目：商品マスタ、2文字目：ウィークリー、3文字目：デイリー、
  // 4文字目：スポット、5文字目：見切り品、6文字目：注文確認画面表示対象フラグ、
  // 7文字目：予備、8文字目：予備
  // 0：表示しない、1：表示する
  // ※ 以下パラメータについては値として返却しているが、フロントエンド側での使用を想定していない
  // 4文字目：スポット
  // 7文字目：予備
  // 8文字目：予備
  private outputDivMap = {
    1: 'category',
    2: 'weekly',
    3: 'daily',
    4: null,
    5: 'logistics',
    6: 'order',
    7: null,
    8: null,
  }

  /** マークグループリスト */
  public markGroupList: GetMarkGroupListResponse = [];

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    this.markGroupList = serverData;
  }

  /**
   * CWSアイコン基本情報を更新する
   *
   * @param serverData CWSアイコン基本情報のサーバ取得データ
   */
  public updateCwsIconBaseData(serverData: any) {
    this.iconName = serverData.IconName;
    this.iconGroup = serverData.IconGroupCode;
    this.iconDiv = serverData.IconDiv;
    this.arrangeDiv = serverData.ArrangeDiv;
    this.iconExplain = serverData.IconExplain;
    this.convertOutputDiv(serverData.OutputDiv)
  }

  /**
   * 出力区分をチェックボックス表示用のbool値へ変換する
   *
   * @param outputDiv 00100010といった形式の出力区分
   */
  private convertOutputDiv(outputDiv: string) {
    const outputDivList = outputDiv.split('');
    outputDivList.reverse();
    for (var i = 0; i < outputDivList.length; i++){
      if (this.outputDivMap[i+1] !== null) {
        this[this.outputDivMap[i+1]] = outputDivList[i] === '1';
      }
    }
  }

  /**
   * チェックボックスの出力区分を更新API用の00100010といった形式で取得する
   */
  public getOutputDiv(): string {
    let outputDiv = '';
    for (var i = 0; i < Object.keys(this.outputDivMap).length; i++){
      if (this.outputDivMap[i+1] !== null && this[this.outputDivMap[i+1]]) {
        outputDiv = '1' + outputDiv;
      } else {
        outputDiv = '0' + outputDiv;
      }
    }
    return outputDiv;
  }
}
